export function gql(strings, ...args) {
  let str = "";
  strings.forEach((string, i) => {
    str += string + (args[i] || "");
  });
  return str;
}
export const HomePartsFragmentDoc = gql`
    fragment HomeParts on Home {
  __typename
  header {
    __typename
    pretitle
    title
    subtitle
    button {
      __typename
      label
      link
    }
    image
  }
  complianceStandards {
    __typename
    title
    standards {
      __typename
      label
      logo
      link
    }
  }
  features {
    __typename
    pretitle
    title
    subtitle
    features {
      __typename
      title
      description
    }
  }
  callToAction {
    __typename
    title
    benefits {
      __typename
      title
    }
    button {
      __typename
      label
      link
    }
    image
  }
  partnerProgram {
    __typename
    pretitle
    title
    subtitle
    button {
      __typename
      label
      link
    }
    benefits {
      __typename
      title
      description
    }
    image
  }
  faqs {
    __typename
    pretitle
    title
    faqs {
      __typename
      question
      answer
    }
  }
  cta {
    __typename
    title
    description
    image
    button {
      __typename
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const ProductPartsFragmentDoc = gql`
    fragment ProductParts on Product {
  __typename
  header {
    __typename
    title
    subtitle
    button {
      __typename
      label
      link
    }
    image
  }
  primaryFeatures {
    __typename
    features {
      __typename
      pretitle
      title
      description
      image
    }
  }
  secondaryFeatures {
    __typename
    pretitle
    title
    subtitle
    description
    features {
      __typename
      title
      description
    }
  }
  faqs {
    __typename
    pretitle
    title
    faqs {
      __typename
      question
      answer
    }
  }
  cta {
    __typename
    title
    description
    image
    button {
      __typename
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const PricingPartsFragmentDoc = gql`
    fragment PricingParts on Pricing {
  __typename
  title
  subtitle
  button {
    __typename
    label
    link
  }
  pricingPlans {
    __typename
    title
    subtitle
    price
    priceSuffix
    description
    button {
      __typename
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const BookDemoPartsFragmentDoc = gql`
    fragment BookDemoParts on BookDemo {
  __typename
  title
  description
  benefits {
    __typename
    benefit
  }
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const ArticlesPagePartsFragmentDoc = gql`
    fragment ArticlesPageParts on ArticlesPage {
  __typename
  title
  subtitle
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const ArticlePartsFragmentDoc = gql`
    fragment ArticleParts on Article {
  __typename
  title
  imageTemplate
  date
  published
  translations {
    __typename
    locale
    title
    body
    summary
    keywords
  }
}
    `;
export const ArticlesListDocument = gql`
    query articlesList($first: Float, $filter: ArticleFilter) {
  articleConnection(first: $first, filter: $filter) {
    edges {
      node {
        ... on Document {
          _sys {
            filename
          }
        }
        title
        imageTemplate
        date
        published
        translations {
          locale
          title
          summary
        }
      }
    }
  }
}
    `;
export const HomeDocument = gql`
    query home($relativePath: String!) {
  home(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...HomeParts
  }
}
    ${HomePartsFragmentDoc}`;
export const HomeConnectionDocument = gql`
    query homeConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: HomeFilter) {
  homeConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...HomeParts
      }
    }
  }
}
    ${HomePartsFragmentDoc}`;
export const ProductDocument = gql`
    query product($relativePath: String!) {
  product(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...ProductParts
  }
}
    ${ProductPartsFragmentDoc}`;
export const ProductConnectionDocument = gql`
    query productConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: ProductFilter) {
  productConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...ProductParts
      }
    }
  }
}
    ${ProductPartsFragmentDoc}`;
export const PricingDocument = gql`
    query pricing($relativePath: String!) {
  pricing(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...PricingParts
  }
}
    ${PricingPartsFragmentDoc}`;
export const PricingConnectionDocument = gql`
    query pricingConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: PricingFilter) {
  pricingConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...PricingParts
      }
    }
  }
}
    ${PricingPartsFragmentDoc}`;
export const BookDemoDocument = gql`
    query bookDemo($relativePath: String!) {
  bookDemo(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...BookDemoParts
  }
}
    ${BookDemoPartsFragmentDoc}`;
export const BookDemoConnectionDocument = gql`
    query bookDemoConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: BookDemoFilter) {
  bookDemoConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...BookDemoParts
      }
    }
  }
}
    ${BookDemoPartsFragmentDoc}`;
export const ArticlesPageDocument = gql`
    query articlesPage($relativePath: String!) {
  articlesPage(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...ArticlesPageParts
  }
}
    ${ArticlesPagePartsFragmentDoc}`;
export const ArticlesPageConnectionDocument = gql`
    query articlesPageConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: ArticlesPageFilter) {
  articlesPageConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...ArticlesPageParts
      }
    }
  }
}
    ${ArticlesPagePartsFragmentDoc}`;
export const ArticleDocument = gql`
    query article($relativePath: String!) {
  article(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...ArticleParts
  }
}
    ${ArticlePartsFragmentDoc}`;
export const ArticleConnectionDocument = gql`
    query articleConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: ArticleFilter) {
  articleConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...ArticleParts
      }
    }
  }
}
    ${ArticlePartsFragmentDoc}`;
export function getSdk(requester) {
  return {
    articlesList(variables, options) {
      return requester(ArticlesListDocument, variables, options);
    },
    home(variables, options) {
      return requester(HomeDocument, variables, options);
    },
    homeConnection(variables, options) {
      return requester(HomeConnectionDocument, variables, options);
    },
    product(variables, options) {
      return requester(ProductDocument, variables, options);
    },
    productConnection(variables, options) {
      return requester(ProductConnectionDocument, variables, options);
    },
    pricing(variables, options) {
      return requester(PricingDocument, variables, options);
    },
    pricingConnection(variables, options) {
      return requester(PricingConnectionDocument, variables, options);
    },
    bookDemo(variables, options) {
      return requester(BookDemoDocument, variables, options);
    },
    bookDemoConnection(variables, options) {
      return requester(BookDemoConnectionDocument, variables, options);
    },
    articlesPage(variables, options) {
      return requester(ArticlesPageDocument, variables, options);
    },
    articlesPageConnection(variables, options) {
      return requester(ArticlesPageConnectionDocument, variables, options);
    },
    article(variables, options) {
      return requester(ArticleDocument, variables, options);
    },
    articleConnection(variables, options) {
      return requester(ArticleConnectionDocument, variables, options);
    }
  };
}
import { createClient } from "tinacms/dist/client";
const generateRequester = (client) => {
  const requester = async (doc, vars, options) => {
    let url = client.apiUrl;
    if (options?.branch) {
      const index = client.apiUrl.lastIndexOf("/");
      url = client.apiUrl.substring(0, index + 1) + options.branch;
    }
    const data = await client.request({
      query: doc,
      variables: vars,
      url
    }, options);
    return { data: data?.data, errors: data?.errors, query: doc, variables: vars || {} };
  };
  return requester;
};
export const ExperimentalGetTinaClient = () => getSdk(
  generateRequester(
    createClient({
      url: "https://content.tinajs.io/1.5/content/f63b45ad-399e-462a-b3a8-57d9cabde043/github/main",
      queries
    })
  )
);
export const queries = (client) => {
  const requester = generateRequester(client);
  return getSdk(requester);
};
